import { API } from "../../../utils";

// Get stock submissions list with params for search, sorting, pagination, filters
export const getSubmissionListApi = async (params = {}) => {
  const response = await API.get("/stock-submissions", { params });
  return response.data;
};

// Get stock submission details by ID
export const getSubmissionDetailsApi = async (id) => {
  const response = await API.get(`/stock-submissions/${id}`);
  return response.data;
};

// Move submission to draft (status = 2)
export const moveToDraftApi = async (id) => {
  const response = await API.put(`/stock-submissions/${id}/status`, null, {
    params: { status: 2 },
  });
  return response.data;
};

// Export stock submission as PDF
export const exportSubmissionPdfApi = async (id) => {
  const response = await API.get(`/stock-submissions/${id}/export-pdf`, {
    responseType: "blob",
  });
  return response;
};

// Export stock submission as Excel
export const exportSubmissionExcelApi = async (id) => {
  const response = await API.get(`/stock-submissions/${id}/export-excel`, {
    responseType: "blob",
  });
  return response;
};
